// src/services/ChatService.js
import api from './api'; // Certifique-se de que o arquivo api.js está configurado corretamente (por exemplo, com axios)

const ChatService = {
  // Obtém o histórico de mensagens para um determinado contexto (ex.: "projeto" ou "monografia") e ID
  getMessages: (context, contextId) => {
    return api.get(`/chat/messages?context=${context}&context_id=${contextId}`);
  },
  // Envia uma mensagem (o payload deve conter: context, context_id, sender e message)
  sendMessage: (payload) => {
    return api.post('/chat/messages', payload);
  }
};

export default ChatService;
